<template>
    <v-card
        color="dark"
        dark
        class="rounded-xl pb-3"
    >
        <div
            style="display: flex; justify-content: space-between; flex-wrap: wrap"
        >
            <div class="mx-4 pt-3">
                <span class="text-small-grey">{{ $t('recognitions.userRecognized') }}</span>
                <div
                    class="mb-0 pt-0 mt-0"
                >
                    <span class="text-post">
                        {{ recognizedUser }}
                    </span>
                </div>
            </div>
            <div class="mx-4 pt-3">
                <!-- <span class="text-small-grey">{{ $t('recognitions.typeRecognitions') }}</span>
                <span class="text-post">{{ typeRecognition }}</span> -->

                <span class="text-small-grey mt-2">{{ $t('behaviours.filterTypes') }}</span>
                <span class="text-post"> {{ typesBehaviour }} </span>
            </div>
        </div>

        <purposeText :purpose="item">
            <span class="text-small-grey">{{ $t('recognitions.textForRecognize') }}</span>
        </purposeText>

        <!--      v-if="competitionEnded === false && canShowCoins(item)"-->
        <likesComponnents
            :purpose-id="+item.id"
            :recognized_user_id="item.attributes.recognized_user_id"
            :type_recognition="item.attributes.type_recognition"
            v-on="$listeners"
        />
        <!--        <div style="display: flex; justify-content: center; flex-wrap: wrap">
            <div class="mx-4">
                <span class="text-small-grey">
                    <c-icon
                        class="mr-1"
                        icon
                        mdi-icon="mdi-eye"
                        @click="goToSeeAll"
                    />{{ $tc('votesRecognitions.countRecognitions', item.recognitions.length) }}</span>
            </div>
        </div>-->

        <!--        <v-divider />-->

        <v-row>
            <v-col
                v-if="!isOnlyView"
                class="mr-4 my-0"
                style="display: flex; justify-content: flex-end"
            >
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            :size="$vuetify.breakpoint.smAndUp ? '35px' : '28px'"
                            class="mr-2"
                            v-bind="attrs"
                            @click="editItem(item)"
                            v-on="on"
                        >
                            mdi-file-document-edit
                        </v-icon>
                    </template>

                    <span>{{ $t('common.edit') }}</span>
                </v-tooltip>

                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            :size="$vuetify.breakpoint.smAndUp ? '35px' : '28px'"
                            v-bind="attrs"
                            @click="deleteItem(item)"
                            v-on="on"
                        >
                            mdi-delete-forever
                        </v-icon>
                    </template>

                    <span>{{ $t('common.delete') }}</span>
                </v-tooltip>
            </v-col>
        </v-row>

        <confirm-dialog
            ref="confirm"
        />
    </v-card>
</template>

<script>

import likesComponnents from "@/components/likes/likesComponnents";
import purposeText from "@/components/purpose/purposeText";
// import purposeDate from "@/components/purpose/purposeDate";
import axios from "@/plugins/axios";

import typesRecognitions from '@/data/typesRecognitions'
import typesBehaviours from '@/data/typesBehaviours'
import { mapGetters } from "vuex";

export default {
    name: "VoteRecognitionSingle",
    components: { purposeText, likesComponnents /*, purposeDate */ },
    props: {
        item: {
            type: Object,
            required: true,
            default() {
                return {};
            }
        },
        isOnlyView: {
            type: Boolean,
            default: true
        }
    },
    data: function () {
        return {
            urlMain: '/purposes'
        }
    },
    computed: {
        ...mapGetters("languages", ['getLang']),
        typeRecognition() {
            if (this.item) {
                const type = typesRecognitions.find(t => t.id === this.item.attributes.type_recognition);
                if (type) { return type[`name_${this.getLang}`]; }
            }
            return '...';
        },
        typesBehaviour() {
            if (this.item) {
                const type = typesBehaviours.find(t => t.id === this.item.attributes.type_behaviour);
                if (type) { return type[`name_${this.getLang}`]; }
            }
            return '...';
        },
        recognizedUser() {
            return (this.item?.userData?.attributes?.name ?? "") + " " + (this.item?.userData?.attributes?.lastname ?? "");
        }
    },
    async mounted() {

    },
    methods: {
        /* goToSeeAll() {
             this.$router.push({ name: 'SeeRecognitionsPersonType', params: { item: JSON.stringify(this.item) } });
        }, */
        editItem(item) {
            this.$router.push({ name: 'RecognitionCreate', params: { item: JSON.stringify(item) } });
        },
        async deleteItem(item) {
            if (
                await this.$refs.confirm.open(
                    this.$t('common.confirmTitle'),
                    this.$t('recognitions.confirmMSGDelete')
                )
            ) {
                this.deleteItemConfirmed(item)
            }
        },
        async deleteItemConfirmed(item) {
            const urlAppend = item.id ? '/' + item.id : '';

            try {
                const result = await axios
                    .delete(this.urlMain + urlAppend);

                if (result.status === 204) {
                    // snackbar/
                    this.$store.dispatch('snackbar/success', this.$t('common.deleteOK'));

                    this.$emit('update:recognitions');
                }
            } catch (error) {
                /* if (error.response) {
        console.log(error.response.data.error) // "invalid_credentials"
        console.log(error.response.status)
        console.log(error.response.headers)
    } */
            }
            this.$store.dispatch('loading/end')
        }
    }
}
</script>

<style scoped>

</style>
